module.exports = __webpack_public_path__ + "img/Locker.f7a855ca.png";